import { useRef, useState, useEffect } from "react";
import Player from "@vimeo/player";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";

import Header from "../header";
import Course from "../course";
import styles from "../home/index.module.css";
import { CheckImage, logo, LogoImage } from "../imagepath";
import AuthServices from "../../services/AuthServices";
const Include = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  const iframeRef = useRef(null);
  const playerRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(true);
  useEffect(() => {
    if (iframeRef.current) {
      playerRef.current = new Player(iframeRef.current);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (iframeRef.current) {
    playerRef.current = new Player(iframeRef.current);
  }

  const handlePlay = () => {
    playerRef.current?.play();
    setIsPlaying(false);
  };

  const handlePause = () => {
    playerRef.current?.pause();
    setIsPlaying(true);
  };

  return (
    <div className="main-wrapper">
      <Header />
      
      <Course/>
      <section
        className={`d-flex align-items-center ${styles.pricingContent}`}
        style={{ justifyContent: "space-around", padding: "100px 20px" }}
      >
        <div style={{ justifyItems: "center", width: "100%" }}>
          <p className="mb-5" style={{ maxWidth: "1200px" }}>
            The AngelWatch Certification Program, part of the AngelWatch
            National Accreditation Program under the AngelWatch Foundation, is
            the only emergency preparedness and safety training system in the
            United States built exclusively for schools, daycares, and colleges.
            Designed for educators, caregivers, and administrators, this program
            goes far beyond state requirements—because state mandates alone
            aren’t enough. <br /> <br />
            State agencies require that centers and campuses have emergency
            protocols and staff training in place—but they don’t offer the
            tools, training, or systems needed to meet those mandates. That
            responsibility falls entirely on the school, daycare, or college.
            And when tragedy strikes, the blame—and the consequences—are placed
            squarely on the institution. That can mean failed audits, loss of
            licensing, lawsuits, irreversible reputational damage, and most
            tragically, the loss of innocent lives. <br />
            <br />
            Most so-called “trainings” are inadequate. They’re passive video
            lectures, one-time check-the- box courses, or recycled workplace
            safety content that was never built for an education setting.
            AngelWatch is different. Built by international defense
            professionals who’ve protected U.S. government facilities and
            personnel worldwide, this program was designed using post-9/11
            protocols and is backed by the Department of Homeland Security, the
            American Red Cross, and the American Heart Association. <br />
            <br />
            Through fully interactive, scenario-based training and real-world
            testing, your entire team gains not just compliance—but confidence.
            With built-in certification tracking, plug-and-play Standard
            Operating Procedures, and a state-compliant Emergency Management
            Protocol Handbook, you’ll be fully prepared, always
            inspection-ready, and able to prove you’ve done everything to
            protect your students, staff, and institution.
            <br />
            <br />
            When lives are on the line, there’s no room for guesswork.
            AngelWatch doesn’t just help you meet the standard—it becomes the
            standard.
          </p>
          
          
          <p className={styles.warning} title="Pass emergency inspections">Schools that fail emergency inspections risk fines, lawsuits, and closure. AngelWatch instantly prepares your team to pass inspections and protect lives.</p>
          <h2 className={`${styles.pricingText} mt-5`}>Avoid Fines and Protect Lives — Start Today</h2>
          <div
            className={`d-flex flex-row gap-5 justify-content-center w-75 ${styles.custom100Width} ${styles.displayBlock} ${styles.pricing__mobile} ${styles.firstPricing__mobile}`}
          >
            <div className="d-block d-lg-flex justify-content-between gap-2 w-100">
              <div className="w-100 w-lg-50" style={{ justifyItems: "center" }}>
                <p
                  className={styles.priceDes}
                  style={{ minHeight: "200px", maxWidth: "400px" }}
                >
                  The Individual Plan is a comprehensive training and
                  certification platform designed for educators, caregivers, and
                  child development professionals. It offers on-demand access to
                  emergency preparedness training, compliance tracking, and
                  certification management—all tailored for individuals who want
                  to stay current, confident, and fully compliant in their
                  field.
                </p>
                <div className={styles.pricingCard}>
                  <img
                    src={require("../../assets/img/discount2.jpg")}
                    className={styles.pricingDiscount}
                  ></img>
                  <span>For Individual Teachers & Caregivers</span>
                  <div className={styles.pricingPrice}>
                    <p className={styles.pricingNum}>$159.00</p>
                    <del className={styles.pricingOriginal}>Was $199</del>
                  </div>
                  <div className={styles.pricingList}>
                    <p className={styles.priceDes}>What’s included:</p>
                    <div className={styles.pricingCardText}>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Full access to our interactive, scenario-based
                          certification course
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Required testing to ensure you’re prepared for
                          real-world emergencies
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Unlimited logins throughout the year to refresh and
                          recertify as needed
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Printable certification upon successful completion
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <p>This plan is ideal for:</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Teachers or aides working in multiple centers</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Substitute or floating staff</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Solo childcare providers</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <p>No surprise fees. No per-certification charges.</p>
                      </div>
                    </div>
                    <Link to="/selectregister" className={styles.priceButton}>
                      <button className={styles.pricingBtn}>Sign Up</button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-100 w-lg-50" style={{ justifyItems: "center" }}>
                <p
                  className={styles.priceDes}
                  style={{ minHeight: "200px", maxWidth: "400px" }}
                >
                  The Center Plan is an all-inclusive Emergency Management
                  System and Certification Platform for licensed schools and
                  childcare providers. It replaces outdated methods with a
                  modern solution that combines emergency training, full staff
                  tracking, document compliance, and audit preparedness. This
                  plan is built for center directors who need to manage and
                  certify entire teams quickly and effectively.
                </p>
                <div className={styles.pricingCard}>
                  <img
                    src={require("../../assets/img/discount2.jpg")}
                    className={styles.pricingDiscount}
                  ></img>
                  <span>For Schools & Daycares</span>

                  <div className={styles.pricingPrice}>
                    <p className={styles.pricingNum}>$800.00</p>
                    <del className={styles.pricingOriginal}>Was $1000</del>
                    <p className={styles.pricingUnit}>/ Entire Staff</p>
                  </div>
                  <div className={styles.pricingList}>
                    <p className={styles.priceDes}>What’s included:</p>
                    <div className={styles.pricingCardText}>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Unlimited staff logins and certifications for 12
                          months
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          On-demand interactive training with real-world
                          emergency scenarios
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Required testing and documentation for full
                          certification
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Full emergency protocol rewrite by our accreditation
                          team (FREE)
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Emergency Management Handbook that aligns with state
                          mandates (FREE)
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          SOPs (Standard Operating Procedures) that plug
                          directly into existing plans (FREE)
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Centralized admin dashboard for tracking staff
                          progress and compliance
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Auto-alerts for expired certifications and staff
                          updates
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          One-click download for audits and licensing inspectors
                        </p>
                      </div>
                    </div>
                    <Link to="/selectregister" className={styles.priceButton}>
                      <button className={styles.pricingBtn}>Sign Up</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <p className={`mt-5 ${styles.certificationTitle1}`}>
        🔹 AngelWatch is the only all-in-one certification and compliance
        solution built for schools and daycares—backed by national partners,
        protected by patent, and proven to work.
      </p>
      <div className={styles.cta}>
        <h1 className={`text-white ${styles.cta__title}`}>
          Protect your children. Protect your staff. Stay compliant.
        </h1>
        <Link to="/getCertified">
          <button className={styles.cta__button}>
          Get Protected with AngelWatch Now -&gt;
          </button>
        </Link>
      </div>

      <section className={styles.contact__section}>
        <h1 className={styles.contact__heading}>Contact Us</h1>
        <div className={styles.contact}>
          <div>
            <h2 className={styles.contact__title}>
              For more information contact us
            </h2>
            <div>
              <img src={LogoImage} className={styles.contact__logoImg}></img>
            </div>
            <div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/email.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>Edu@AngelWatch.org</p>
              </div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/call.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>+1 800-381-6794</p>
              </div>
            </div>
          </div>
          <div className={styles.contact__form}>
            <div>
              <p>Your name</p>
              <input
                type="text"
                className={styles.contact__input__info}
                placeholder="John Smith"
                name="name"
                value={formData.name}
                onChange={handleChange}
              ></input>
            </div>
            <div>
              <p>Your email</p>
              <input
                type="email"
                name="email"
                className={styles.contact__input__info}
                placeholder="abc@gmail.com"
                value={formData.email}
                onChange={handleChange}
              ></input>
            </div>
            <div className={styles.contact__message__form}>
              <p>Your message</p>
              <textarea
                type="text"
                name="message"
                className={styles.contact__message__input}
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
              style={{ marginBottom: "20px" }}
              onClick={handleSendMessage}
              disabled={!handleCaptchaChange}
            >
              Send Message
            </button>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              onChange={handleCaptchaChange}
              className={`${styles.captcha}`}
            />
          </div>
        </div>
      </section>

      {/* Master Skills */}
      {/* /Master Skills */}
      <section className="d-flex flex-column">
        <div className={styles.footerTop}>
          <div className={styles.footerSection}>
            <img className={styles.footerImage} src={logo} />
            <p className={styles.footerDes}>
              All of our techniques, trainings, equipment, software, hardware
              and instructions are considered classified material and owned by
              the AngelWatch Foundation. We do not share our information on how
              we teach. The reason, we keep the center, staff and children
              protected at all times. We never want anyone to try to figure out
              a way to bypass our trainings. We always improve, change and adapt
              to make sure that we have every base covered.
            </p>
          </div>

          <div className={styles.footerLoginSection}>
            <p className={styles.footerTitle}>School</p>
            <Link to="/login">
              <a className={styles.footerLink1}>Login</a>
            </Link>
            <Link to="/selectregister">
              <a className={styles.footerLink1}>Register</a>
            </Link>
          </div>

          <div className={styles.footerSection}>
            <p className={styles.footerTitle}>Newsletter</p>
            <input
              className={styles.newsLetter}
              placeholder="Enter your email address"
              type="text"
            />
            <p className={styles.footerLink1}>
              Hampton Reserve Drive, Brentwood tennessee, 37027
            </p>
            <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
            <p className={styles.footerLink1}>+1 800-381-6794</p>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.footerBottomLeft}>
            <p className={styles.footerLink}>Term</p>
            <p className={styles.footerLink}>|</p>
            <p className={styles.footerLink}>Privacy</p>
          </div>
          <div className={styles.footerBottomRight}>
            <p className={styles.footerLink}>
              © 2025 AngelWatch LMS. All rights reserved.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Include;
